import { useRef } from 'react';

import { motion } from 'framer-motion';

import useScrollVelocityX from '../../hooks/useScrollVelocityX';

import useGsapSection from '../../hooks/useGsapSection';

import useGsapInView from '../../hooks/useGsapInView';

import { BlurSplitText, ScrambleReveal, ClipRevealText } from '../TextEffects';

import { ABOUT_CLIENTS } from '../../data/about';

import './ClientsSection.css';



const partners = ABOUT_CLIENTS.map((name) => ({

  id: name.toLowerCase().replace(/[^a-z0-9]+/g, '-'),

  name,

  mark: name,

}));



const ClientsSection = () => {

  const ref = useRef(null);

  const titleRef = useRef(null);

  const inView = useGsapSection(ref, { revealY: 24 });

  const titleInView = useGsapInView(titleRef);

  const x = useScrollVelocityX(-0.7);



  return (

    <section

      id="clients"

      ref={ref}

      className="partners"

      data-testid="clients-section"

    >

      <div className="partners-strip">

        <span className="partners-strip-left gsap-reveal">

          <span className="partners-strip-num">(006)</span>

          <span className="partners-strip-divider" />

          <ClipRevealText text="Selected Clients" delay={0.05} externalInView={inView} />

          {' '}

          <ScrambleReveal text="& Clients" delay={0.15} externalInView={inView} />

        </span>

        <span className="partners-strip-right tabular gsap-reveal">

          <ScrambleReveal

            text={`${String(partners.length).padStart(2, '0')} engagements`}

            delay={0.2}

            externalInView={inView}

          />

        </span>

      </div>



      <h2 ref={titleRef} className="partners-lead">

        <span className="partners-lead-line">

          <BlurSplitText

            text="A selection of studios, agencies"

            as="span"

            delay={0.1}

            stagger={0.035}

            externalInView={titleInView}

          />

        </span>

        <span className="partners-lead-line">

          <BlurSplitText

            text="and brands I've worked with."

            as="span"

            delay={0.25}

            stagger={0.035}

            externalInView={titleInView}

          />

        </span>

      </h2>



      <div className="partners-marquee gsap-reveal">

        <div className="partners-row">

          <motion.div className="partners-track" style={{ x }}>

            {[...partners, ...partners].map((p, i) => (

              <span

                key={`${p.id}-${i}`}

                className="partners-item"

                data-testid={`partner-${p.id}`}

              >

                <span className="partners-item-mark">{p.mark}</span>

                <span className="partners-item-sep" aria-hidden="true">✦</span>

              </span>

            ))}

          </motion.div>

        </div>

      </div>

    </section>

  );

};



export default ClientsSection;

